import { InputFieldSet } from "PFComponents/text/input_field_set";
import React, { JSX } from "react";
import { useTranslation } from "react-i18next";

import { useAnalyticsModalContext } from "../../../analytics_modal_context_provider";
import { CreateNewTemplate } from "./create_new_template/create_new_template";
import css from "./export_tab.module.scss";

export const ExportTab = (): JSX.Element => {
  const { t } = useTranslation("insights", { keyPrefix: "exportWizard" });
  const {
    state: {
      data: { reportName }
    },
    updateData
  } = useAnalyticsModalContext();

  return (
    <div>
      <InputFieldSet
        label={t("reportName")}
        className={css.newReport}
        kind="bordered"
        value={reportName}
        onChange={(value) => updateData({ reportName: value })}
        maxLength={100}
      />
      <CreateNewTemplate />
    </div>
  );
};
